import { createAction, props } from '@ngrx/store';
import { LocationNetworkModel } from '../../../data-models';

export const loadCareData = createAction(
  '[Patients Care] Load',
  props<{ columns: string[]; collection: LocationNetworkModel[] }>()
);
export const clearCareData = createAction('[Patients Care] Clear');
